// extracted by mini-css-extract-plugin
module.exports =  {"License":"Jau1B4dmqV4PXC2b7I6_"};